<template>
  <div>
    <div
      v-for="(item, index) in selectShablonJson"
      :key="index"
      class="kundalik-loop"
      :style="{ 'margin-top': item.number + '%' }"
    >
      <div>
        <label>Sana {{ item.day }}</label> <br />

        <div class="label multiline-text">{{ item.text }}</div>
        <label><b>Shifokor</b> {{ item.doctor }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectShablonJson: {},
      data: {}
    };
  },
  created: function() {
    this.data = JSON.parse(localStorage.getItem("kundalik"));
    console.log(this.data);
    this.selectShablonJson = this.data.value;
  },
  mounted() {
    localStorage.removeItem("kundalik");
    window.print();
    setTimeout(() => {
      //   this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.multiline-text {
  white-space: pre-line;
}
.kundalik-loop {
  page-break-after: auto;
  // width: 800px;
  margin: 10px 0;
}
.label {
  font-family: "Times New Roman", Times, serif;
  // margin-top: 5px;
  font-size: 14pt;
  line-height: 14pt;
  // font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
}
.display-flex {
  display: flex;
}
</style>
